import { render, staticRenderFns } from "./housingInfo.vue?vue&type=template&id=525e9139&scoped=true"
import script from "./housingInfo.vue?vue&type=script&lang=js"
export * from "./housingInfo.vue?vue&type=script&lang=js"
import style0 from "./housingInfo.vue?vue&type=style&index=0&id=525e9139&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "525e9139",
  null
  
)

export default component.exports